import SaveDocumentRequest from '@/modules/common/hiring/models/MID/requests/SaveDocumentRequest'
import type Insured from '@/modules/common/common/models/APP/Insured'
import CommonMapper from '@/modules/core/mappers/CommonMapper'
import PolicyHolderSaveDocument from '@/modules/common/common/models/MID/PolicyHolderSaveDocument'

export default class SaveDocumentMapper {
  static async toRequest(quotationId: string, holder: Insured): Promise<SaveDocumentRequest> {
    const policyHolder = new PolicyHolderSaveDocument({
      nacionality: holder.addressDetails.country,
      personType: holder.documentDetails.personType,
      documentType: holder.documentDetails.documentType,
      documentNumber: holder.documentDetails.documentNumber,
      privacyPolicyConsent: holder.privacyPolicyConsent,
      birthDate: CommonMapper.toMiddlewareDate(holder.userDetails.birthDate)
    })

    if (holder.documentDetails.documentExpirationDate) {
      policyHolder.documentExpirationDate = CommonMapper.toMiddlewareDate(
        holder.documentDetails.documentExpirationDate
      )!
    }

    return new SaveDocumentRequest({
      quotationId,
      document: [],
      policyHolder
    })
  }
}
